import { userLoggedOut } from "../auth/authSlice";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "app/utils/axiosInstance";
const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: async (headers, { getState, endpoint }) => {
    const token = getState()?.auth?.accessToken;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    return headers;
  }
});

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    if (result?.error?.status === 401) {
      const isLoginUrl = typeof args === 'string' ? args.includes('/auth/login') : args?.url?.includes('/auth/login');
      if (!isLoginUrl) {
        api.dispatch(userLoggedOut());
        localStorage.clear();
      }
    }
    return result;
  },
  // baseQuery: fetchBaseQuery({ baseUrl: "http://localhost:3000", axios }),
  tagTypes: [],
  endpoints: (builder) => ({})
});
